import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { DFPService } from '@services/http/dfp/dfp.service';
import DfpComponent from '@features/dashboard/performance/pages/dfp/dfp.component';
import { PartnerDealDfpService } from './partner-deal-dfp.service';

/**
 * Aba Análise econômica da tela do deal na visão do PARCEIRO (card 3307, T03).
 *
 * A mesma DFP Histórica do time interno (`app-dfp` embutida), em modo somente leitura (`readOnly`): sem
 * exportar, sem documentos de origem, sem comentários, sem De/Para e sem o chat de IA. Os dados vêm de
 * `partners/deals/{dealId}/economic-analysis/*` (`PartnerDealDfpService`), que confere que o deal é do
 * parceiro e usa a empresa do deal. O time interno continua na `app-deal-economic-analysis-tab`, que lê
 * `dfp-historical/*` sem escopo de empresa (card 3298).
 */
@Component({
  selector: 'app-deal-partner-economic-analysis-tab',
  standalone: true,
  imports: [DfpComponent],
  providers: [PartnerDealDfpService, { provide: DFPService, useExisting: PartnerDealDfpService }],
  template: `<app-dfp [companyId]="companyId()" [embedded]="true" [readOnly]="true" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealPartnerEconomicAnalysisTabComponent implements OnInit {
  readonly dealId = input.required<string>();
  readonly companyId = input.required<string>();

  private readonly dfpService = inject(PartnerDealDfpService);

  /** Antes da DFP embutida carregar: o `ngOnInit` do pai roda antes do filho ser criado. */
  ngOnInit(): void {
    this.dfpService.useDeal(this.dealId());
  }
}
